import { RemoveRedEye } from '@mui/icons-material';
//import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Button, Link } from '@mui/material';
import React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import CvAnonyme from '../../../Components/Docs/CvAnonyme';
import { buttonStyles, buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { InvitationButton, MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { API_SERVER_FILES } from '../../../config';
import { expertTypeEsn, genreTitres, StatutsMisionEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { calculateTotalAnneeExperience, getNomPrenomClearFromPersoData, isHttpStatusSuccess, searchLabelInEnumByValue, ValiderDocAdministratifs, ValiderDocAdministratifsExpert } from '../../../Utils/utils';

function FicheExperts() {
    const { addEuro4Decimal } = useNumberFormatting();

    const [expertsUsers, setExpertsUsers] = useState();
    const [dataExpert, setDataExperts] = useState();
    // const [isDossierCandidat,setIsDossierCandidat]=useState(false);
    const axiosPrivate = useAxiosPrivate();
    const { postData } = usePostRequest();
    const { i18n } = useTranslation();
    const [expertId, setExpertId] = useState();
    const [openCvAnonyme, setOpenCvAnonyme] = React.useState(false);
    const [expert, setExpert] = useState();
    const navigate = useNavigate();
    const { setBackdropOpen } = useUtilities();
    const { device } = useWindowSize();
    const role = useRole();
    const {pathname}=useLocation();
    const columns = [
        {
            field: 'refExpert',
            title: i18n.t('Réf.expert'),
            render: rowData => (
                <Button
                    variant='text'
                    onClick={() => {
                        if(pathname.includes('gestionDossiersCandidats')){
                            navigate(`/${role}/gestionDossiersCandidats/${rowData?.__id}/DonneePersonnel`,
                                {
                                    state: {
                                        type: rowData?.type,
                                        expertId: rowData?.__id,
                                        isCandidat:true,
                                    }
                                }, {replace:true});}
                        else{
                            navigate(`/${role}/gestionExperts/${rowData?.__id}/DonneePersonnel`,
                                {
                                    state: {
                                        type: rowData?.type,
                                        expertId: rowData?.__id,
                                        isCandidat: false
                                    }
                                }, {replace:true});
                        }}}
                >
                    {rowData?.refExpert}
                </Button>
            )
        },
        {
            field: 'type',
            title: i18n.t('Type'),
            render: (rowData) => {
                return i18n.t(rowData?.type);
            },
            hidden: (role=='esn' && pathname.includes('gestionDossiersCandidats')),
        },
        {
            field: 'statutActor',
            title: i18n.t('Statut'),
            hidden: (role === 'admin' || (role=='esn' &&pathname.includes('gestionDossiersCandidats'))), // Masquer le champ si le rôle est 'admin'
        },
        {
            field: 'nom',
            title: i18n.t('Nom'),
        },
        {
            field: 'sousCategorie',
            title: i18n.t('Sous-catégorie'),
        },

        {
            field: 'cvHth',
            title: i18n.t('CV HTH'),
            render: rowData =>
                <RemoveRedEye
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        console.log({ RemoveRedEye: rowData });
                        setOpenCvAnonyme(true);
                        setExpertId(rowData?.expertId?._id);
                        setExpert(rowData?.expertId);
                    }}
                />,
            hidden: role === 'esn', // Masquer le champ si le rôle est 'esn'
        },
        {
            field: 'cvOrigine',
            title: i18n.t('CV d\'origine'),
            render: rowData => (
                <>
                    {rowData?.cvOrigine && (
                        // If the file is a PDF, open it directly else use docs.google.com/gview
                        <Link
                            href={rowData.cvOrigine.endsWith('.pdf') ? (API_SERVER_FILES + encodeURIComponent(rowData.cvOrigine)):(`https://docs.google.com/gview?url=${API_SERVER_FILES}${encodeURIComponent(rowData.cvOrigine)}`)}
                            target="_blank"
                        >
                            <RemoveRedEye />
                        </Link>

                    )}
                </>
            )
            // rowData =>
            //     <>
            //         {rowData?.cvOrigine &&
            //             <Link
            //                 href={API_SERVER_FILES + encodeURIComponent(rowData?.cvOrigine)}
            //                 target="_blank"
            //             >
            //                 <RemoveRedEye />
            //             </Link>}
            //             {'https://docs.google.com/gview?url='+API_SERVER_FILES +document?.url+'&embedded=true'}
            //     </>

        },
        {
            field: 'titre',
            title: i18n.t('Titre'),
        },
        {
            field: 'intituleCV',
            title: i18n.t('Intitulé du CV'),
        },
        {
            field: 'tel',
            title: i18n.t('Tél'),
        },
        {
            field: 'email',
            title: i18n.t('E-mail'),
        },
        {
            field: 'totalExp',
            title: i18n.t('Total Exp.'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.totalExp, i18n.t('ans'));
            }
        },
        {
            field: 'statutDoc',
            title: i18n.t('Statut Doc.administratifs'),
            render: (rowData) => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', justifyContent: 'center' }}>
                        <p style={{ margin: '0px' }}>
                            {i18n.t(rowData?.statutDoc) + ' '}
                            <span>
                                {rowData?.nbDocNonValide !== 0 && (
                                    <span>({rowData?.nbDocNonValide})</span>
                                )}
                            </span>
                        </p>
                    </div>
                );
            },
            hidden: role === 'esn', // Masquer le champ si le rôle est 'esn'
        },

        {
            field: 'statutMission',
            title: i18n.t('Statut mission'),
            render: (rowData) =>
                i18n.t(searchLabelInEnumByValue(StatutsMisionEnum, rowData?.statutMission))
        },
        {
            field: 'nbMission',
            title: i18n.t('Nb de missions'),
        },
        {
            field: 'dateDispo',
            title: i18n.t('Date de disponibilité'),
        },
        {
            field: 'tauxJour',
            title: i18n.t('Taux journalier'),
            render: rowData => {
                return addEuro4Decimal(rowData?.tauxJour);
            }
        },
        {
            field: 'ville',
            title: i18n.t('Ville'),
        },
        {
            field: 'pays',
            title: i18n.t('Pays'),
        },
        {
            field: 'dernierActivite',
            title: i18n.t('Dernière activité'),
        },
        {
            field: 'Evaluation',
            title: i18n.t('Evaluation interne'),
        },
        {
            field: 'inviter',
            title: i18n.t('Inviter un expert (externe)'),
            render: rowData => {
                return (
                    <>
                        <InvitationButton
                            rowData={rowData}
                            getAllExperts={getAllExperts}
                            role={role}
                            isDossierCandidat={role=='esn' && pathname.includes('gestionDossiersCandidats') ? true : false}
                        />
                    </>
                );
            }
        },
        {
            field: 'Option',
            title: i18n.t('Option'),
            render: (rowData) =>{
                return (
                    <Button
                        variant="outlined"
                        onClick={() => blockUser(rowData?.email, rowData?.isBlocked)}
                        //bdc={rowData.clientId}
                        //startIcon={<ArrowBack />}
                    >
                        {rowData?.isBlocked ?  i18n.t('Débloquer') : i18n.t('Bloquer l\'utilisateur')}
                    </Button>
                );
            }

        },
    ];

    async function blockUser(email, isBlocked) {
        try {
            const response = await postData({ url: '/users/blockUser', payload: {
                email,
                isBlocked: !isBlocked,
            } });
            if (isHttpStatusSuccess(response?.responseStatus)) {
                Swal.fire({
                    title: i18n.t(response?.data?.message),
                    icon: 'success',
                    confirmButtonColor: '#5CC889',
                    confirmButtonText: 'Ok',
                }).then((result) => {
                    if(result.isConfirmed){
                        getAllExperts();
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getAllExperts = async () => {
        setBackdropOpen(true);
        try {
            console.log('HELLO FROM the USERS useEffect');
            const url=role=='esn'? (pathname.includes('gestionDossiersCandidats') ? '/users/getAllExperts/?isDossierCandidat=true' :'/users/getAllExperts/?isDossierCandidat=false') : '/users/getAllExperts';
            const response = await axiosPrivate.get(url, {
            });
            console.log(response.data);
            //?  if is mounted==true do next [setUsers..]
            setExpertsUsers(response.data);
        } catch (error) {
            console.log(error);
            //navigate('gestionExpert/' + id);
        }
        setBackdropOpen(false);
    };

    useEffect(() => {
        console.log('expertId', expertId);
    }, []);
    useEffect(() => {
        console.log('expertsUsers',expertsUsers);
    }, [expertsUsers]);

    useEffect(() => {
        // recently start supporting consulation token
        // but support also abortCntrller : concel our request if the conponent didUnmount
        // const controller = new AbortController();
        // ! tocall :
        if(role && pathname){
            getAllExperts();
            // if(pathname?.includes('gestionDossiersCandidats'))
            //     setIsDossierCandidat(true);
        }
        // cleanup fct of use Effect, runs when the compo unMount
    }, [role,pathname]);

    useEffect(() => {
        if (expertsUsers) {
            let Array1 = [];
            let temp1;
            let typeExpert;
            expertsUsers?.reverse()?.forEach(userExpert => {
                if(role=='esn' && pathname.includes('gestionDossiersCandidats')){
                    // console.log('experience',userExpert?.expertId?.proData?.experiences,'totalAnneeExperience',userExpert.expertId?.proData?.otherInfo?.totalAnneeExperience,'calculateTotalAnneeExperience', calculateTotalAnneeExperience(userExpert?.expertId?.proData?.experiences));
                    typeExpert = 'Actif';
                    if ((userExpert?.isActive == false && (userExpert?.inviterBackOfficeId || userExpert?.inviterEsnId)))
                        typeExpert = 'Passif';
                    // console.log('ValiderDocAdministratifs', ValiderDocAdministratifs(userExpert?.expertId?.docsAdministratifs, 'kbis'));
                    temp1 = ValiderDocAdministratifsExpert(userExpert?.docsAdministratifs);
                    console.log('valider', ValiderDocAdministratifsExpert(userExpert?.docsAdministratifs));
                    Array1.push({
                        '__id': userExpert?.proData?.expertId,
                        'type': typeExpert,
                        'refExpert': userExpert?.expertId,
                        'nom': getNomPrenomClearFromPersoData(userExpert?.persoData),
                        'cvOrigine': userExpert?.persoData?.cv,
                        'statutActor':searchLabelInEnumByValue(expertTypeEsn,userExpert?.typeExpertEsn),
                        'titre': i18n.t(searchLabelInEnumByValue(genreTitres, userExpert?.persoData?.genre)),
                        // 'titre': temp,
                        'sousCategorie': userExpert?.persoData?.categorie?.sousCategorie,
                        'intituleCV': userExpert?.persoData?.intitulePoste,
                        'tel': userExpert?.persoData?.tele,
                        'email': userExpert?.email,
                        'isBlocked': userExpert?.isBlocked,
                        'totalExp': userExpert.proData?.otherInfo?.totalAnneeExperience ?? calculateTotalAnneeExperience(userExpert?.proData?.experiences),
                        'ville': userExpert?.preference?.residence?.ville,
                        'pays': userExpert?.preference?.residence?.pays,
                        'statutDoc': temp1.statutDoc,
                        'nbDocNonValide': temp1.compteurDocNonValide,
                        'statutMission': (userExpert?.missions.pop())?.statutMission, //statutMision
                        'nbMission': userExpert?.missions?.length,
                        'dateDispo': formatDateJJMMYYYY(userExpert?.preference?.dateDisponibilite?.date),
                        'dernierActivite': formatDateJJMMYYYY(userExpert?.updatedAt),
                        'tauxJour': userExpert?.preference?.tjm,
                        'Evaluation': '??',
                        ...userExpert,
                    });
                }
                else if (userExpert?.expertId) {
                    console.log('experience',userExpert?.expertId?.proData?.experiences,'totalAnneeExperience',userExpert.expertId?.proData?.otherInfo?.totalAnneeExperience,'calculateTotalAnneeExperience', calculateTotalAnneeExperience(userExpert?.expertId?.proData?.experiences));
                    typeExpert = 'Actif';
                    if (userExpert?.isActive == false && (userExpert?.inviterBackOfficeId || userExpert?.inviterEsnId))
                        typeExpert = 'Passif';
                    console.log('ValiderDocAdministratifs', ValiderDocAdministratifs(userExpert?.expertId?.docsAdministratifs, 'kbis'));
                    temp1 = ValiderDocAdministratifsExpert(userExpert?.expertId?.docsAdministratifs);
                    console.log('valider', ValiderDocAdministratifsExpert(userExpert?.expertId?.docsAdministratifs));
                    Array1.push({
                        '__id': userExpert?.expertId?._id,
                        'type': typeExpert,
                        'refExpert': userExpert?.expertId?.expertId,
                        'nom': getNomPrenomClearFromPersoData(userExpert?.expertId?.persoData),
                        'cvOrigine': userExpert?.expertId?.persoData?.cv,
                        'statutActor':searchLabelInEnumByValue(expertTypeEsn,userExpert?.expertId?.typeExpertEsn),
                        'titre': i18n.t(searchLabelInEnumByValue(genreTitres, userExpert?.expertId?.persoData?.genre)),
                        // 'titre': temp,
                        'sousCategorie': userExpert?.expertId?.persoData?.categorie?.sousCategorie,
                        'intituleCV': userExpert?.expertId?.persoData?.intitulePoste,
                        'tel': userExpert?.expertId?.persoData?.tele,
                        'email': userExpert?.email,
                        'isBlocked': userExpert?.isBlocked,
                        'totalExp': userExpert.expertId?.proData?.otherInfo?.totalAnneeExperience ?? calculateTotalAnneeExperience(userExpert?.expertId?.proData?.experiences),
                        'ville': userExpert?.expertId?.preference?.residence?.ville,
                        'pays': userExpert?.expertId?.preference?.residence?.pays,
                        'statutDoc': temp1.statutDoc,
                        'nbDocNonValide': temp1.compteurDocNonValide,
                        'statutMission': (userExpert?.expertId?.missions.pop())?.statutMission, //statutMision
                        'nbMission': userExpert?.expertId?.missions?.length,
                        'dateDispo': formatDateJJMMYYYY(userExpert?.expertId?.preference?.dateDisponibilite?.date),
                        'dernierActivite': formatDateJJMMYYYY(userExpert?.updatedAt),
                        'tauxJour': userExpert?.expertId?.preference?.tjm,
                        'Evaluation': '??',
                        ...userExpert,
                    });
                }
            });
            setDataExperts(Array1);
        }
    }, [expertsUsers]);

    const [selectedRow, setSelectedRow] = React.useState(null);

    return (
        <>
            <div className='frame5Profile'>{i18n.t('Gestion des experts')}  &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Fiches des experts')} </span> </div>

            <div className='HomeFrame'>
                <h4 className='titlesociete'>{i18n.t('Fiches des experts')}</h4>
                {role=='esn' &&
                    <div className='frame8TableMissionBDCAdmin'>
                        <Button
                            className='frame29CvTheque'
                            onClick={() =>
                            {
                                navigate('/esn/gestionExperts');
                            }}
                            style={
                                (!pathname.includes('gestionDossiersCandidats')) ?
                                    {...buttonStyles(),...{
                                        background: '#E7EAF9',
                                        color: '#214DCE',
                                        borderRadius:'60px',
                                    }}:
                                    {...buttonStyles(),...{
                                        color: '#475063',
                                        borderRadius:'60px',
                                    }}
                            }
                        >
                            {i18n.t('Experts')}
                        </Button>
                        <Button
                            className='frame31CvTheque'
                            onClick={() =>
                            {
                                navigate('/esn/gestionDossiersCandidats');
                                //setClientTable(false);
                            }}
                            style={
                                pathname.includes('gestionDossiersCandidats')  ?
                                    {...buttonStyles(),...{
                                        background: '#E7EAF9',
                                        color: '#214DCE',
                                        borderRadius:'60px',
                                    }}:
                                    {...buttonStyles(),...{
                                        color: '#475063',
                                        borderRadius:'60px',
                                    }}
                            }
                        >
                            {i18n.t('Dossiers candidats')}
                        </Button>
                    </div>
                }
                <div style={{ alignSelf: 'stretch', display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <Button
                        onClick={() => {
                            // Détecte si on est sur la page des dossiers candidats ou des experts
                            const isDossierCandidat = pathname.includes('gestionDossiersCandidats');
                            // Redirige selon la page active
                            // if(role=='esn')
                            //     navigate(`/${role}/AddExpertStep1?isDossierCandidat=${isDossierCandidat}`, { replace: true });
                            // else
                            //     navigate(`/${role}/AddExpertStep1}`, { replace: true });
                            navigate(`/${role}/AddExpertStep1`,{ state: {isCandidat : isDossierCandidat }}, {replace: true });
                        }}
                        // {() =>role=='esn' ? navigate(`/${role}/AddExpertStep1?isDossierCandidat=${isDossierCandidat}`, { replace: true }):navigate(`/${role}/AddExpertStep1}`, { replace: true })}
                        variant='contained'
                        style={{ ...buttonStylesGreen(), ...{ width: device == 'desktop' ? 'auto' : '100%' } }}
                    >
                        {i18n.t('Ajouter un expert')}
                    </Button>
                </div>
                <MaterialTableComponent
                    columns={columns}
                    data={dataExpert}
                    title="Fiches des experts"
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                    }}
                    selectedRow={selectedRow}
                />
                <CvAnonyme
                    openCvAnonyme={openCvAnonyme}
                    setOpenCvAnonyme={setOpenCvAnonyme}
                    expert={expert}
                    visualiseCvOnly={true}
                //titreAO={ao?.intitulePoste}
                //selectedCandidature={selectedCandidature}
                //refreshParentTable={refresh}
                />
            </div>
        </>
    );
}

export default FicheExperts;